<template>
  <router-link :to="link" class="gameListItem" :id="id" :style="{'background-image': 'url(' + this.gameData['imageURL'] + ')'}">
    <div class="filter-brightness">
      <h3 v-html="title"></h3>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'GameListItem',
  props: ['gameData'],
  computed:{
    id: function(){
      return this.gameData.id;
    },
    link: function(){
      return "/game/" + this.gameData.id;
    } ,
    title: function(){
      return this.gameData.title.replace(/\n/g,'<br>');
    }
  }
}
</script>

<style scoped>
/*スマートフォン・タブレット向けデザイン*/
.gameListItem{
  height: calc(calc(90vw * 9) / 16);
  width: 90vw;
  margin: 15px auto;
  padding:0;
  box-shadow: 0 0 2px 2px black;
  border-radius: 5px;
  box-shadow: 3px 3px 2px black;
  background-position: 50% 50%;
  background-size: 110% auto;
  background-repeat:  no-repeat;
  display:block;
  text-decoration: none;
}

.filter-brightness{
  width:100%;
  height:100%;
  margin:0;
  background: rgba(0,0,0,0.2);
  text-align: center;
  display: table;
  
}

.gameListItem div h3{
  text-decoration: none;
  display: table-cell;
  vertical-align:middle;
  font-size: 2.5em;
  color: white;
  text-stroke:1px black;
  -webkit-text-stroke: 1px black;
  text-shadow: 0 2px 2px #666;
}

@media screen and (max-width:599px){
  .gameListItem:last-child{
    margin-bottom: 85px;
  }
}

/* PC向けデザイン */
@media screen and (min-width: 1280px){
  .gameListItem{
    height: 250px;
    width: 800px;
    margin: 15px 0;
  }

  .gameListItem div h3{
    font-size: 50px;
  }
}
</style>
